// frontend/src/config/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth, browserLocalPersistence, setPersistence } from "firebase/auth";

// Detectar si estamos en desarrollo
const isDevelopment = import.meta.env.DEV || window.location.hostname === 'localhost';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCjK-_qmGbAurofUyg-2uw4_1V9Po-OE58",
    authDomain: isDevelopment ? "localhost" : (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "erp-mariaregna.firebaseapp.com"),
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "erp-mariaregna",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "erp-mariaregna.firebasestorage.app",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "1064469773493",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:1064469773493:web:158bf2270923a6800a52fc"
};

// Initialize Firebase App first
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth with the app instance
const auth = getAuth(app);

// Configurar para desarrollo local si es necesario
if (isDevelopment) {
    console.log("🔧 Modo desarrollo detectado - usando localhost como authDomain");
    console.log("🌐 Auth Domain configurado como:", firebaseConfig.authDomain);
}

// Initialize auth persistence after auth is created
const initializeAuthPersistence = async () => {
    try {
        await setPersistence(auth, browserLocalPersistence);
        console.log("🔐 Firebase Auth persistence configurada");
        // console.log("🔐 Firebase Auth persistence configurada");
    } catch (error) {
        console.error("Error setting auth persistence:", error);
    }
};

// Initialize persistence
initializeAuthPersistence();

// console.log("🔥 Firebase App inicializado correctamente");
// console.log("🔐 Firebase Auth inicializado correctamente");
// console.log("🌐 Auth Domain:", firebaseConfig.authDomain);
// console.log("🏠 Current Origin:", window.location.origin);
// console.log("🏗️ Modo desarrollo:", isDevelopment);

export { auth };
export default app;